// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ModuleList } from "../../../components/module_list/ModuleList";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class ModalModule extends ModuleBase {
  protected isVisible: boolean = false;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  mounted() {
    let links = document.getElementsByTagName("a");
    for (let i = 0; i < links.length; i++) {
      let link = links[i];
      if (link.href && link.href.indexOf("#" + this.instance["modalId"]) >= 0) {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.isVisible = true;
        });
      }
    }
  }

  onClose() {
    this.isVisible = false;
  }
}
